import collectdProcessList from './collectdProcessList.js';

angular
    .module('signalview.curated', ['signalview.chartTemplates', 'signalview.analytics'])
    .directive('collectdProcessList', collectdProcessList);
